'use client'

import React from 'react'
import { Button } from '@/components/ui/button'

export function FallbackButtons() {
  return (
    <>
      <Button 
        onClick={() => window.location.reload()} 
        className="w-full"
      >
        Reload Page
      </Button>
      <Button 
        onClick={() => {
          localStorage.clear();
          window.location.href = '/auth/sign-in';
        }} 
        variant="destructive"
        className="w-full"
      >
        Sign Out
      </Button>
    </>
  )
} 